<template>
    <div class="flex justify-content-center align-items-center w-full h-full ">
        <Panel class="panel-class text-center md:p-5 w-full">
            <div class="Paragraph-Medium mb-2">Enter Code</div>
            <p class="Caption block mb-4">Use the code shown in Google Authenticator or
                similar app.</p>

            <div class="flex flex-col gap-1 justify-content-center">
                <InputOtp name="otp" v-model="otp" mask integerOnly variant="filled" size="large" :length="6" />
            </div>
            <div class="flex justify-content-center mt-5">
                <Button label="Verify" class="teal-700-button" :disabled="otp.length < 6" @click="verifyTwoFactor" />
            </div>
        </Panel>
    </div>
</template>

<script setup>
import InputOtp from 'primevue/inputotp';
import { Button, Panel } from 'primevue';
import { ref } from 'vue';
import * as authApi from "@/api/auth";
import { useAuthStore } from "@/stores/authStore";
import { notifyError } from "@/utils/notification";
import { useRouter } from "vue-router";

const router = useRouter();
const authStore = useAuthStore();
const otp = ref("");
const invalidAttempt = ref(0);

const verifyTwoFactor = async () => {
    try {
        const payload = {
            otp: otp.value,
            role: authStore.user?.role,
            userId: authStore.user?.userId,
        };
        const res = await authApi.verifyTwoFactor(payload);
        if (res.data.success) {
            if (authStore.user?.registrationCompleted) {
                router.push('/student_dashboard');
            } else {
                router.push('/studentOnBoarding');
            }
        } else {
            notifyError("Oops!", "Something went wrong. Please try again.");
        }
    } catch (err) {
        if (err.message) {
            invalidAttempt.value += 1;
            notifyError("Unauthorized", "Invalid OTP. Please try again.");
            otp.value = "";
        }
    }
};
</script>
<style scoped>
.panel-class {
    border: none;
    box-shadow: none;
}
</style>